<template>
    <div class="mb-3">
        <label class="d-block">
            <span class="form-label">Search Previous Parts</span>
            <div class="input-group">
                <input 
                    type="text" 
                    class="form-control form-control-sm" 
                    v-model="searchQuery"
                    @input="onSearchInput"
                    placeholder="Search by description or part number..."
                />
                <button 
                    class="btn btn-sm btn-outline-secondary"
                    @click="performSearch"
                    :disabled="!searchQuery"
                >
                    <i class="fa fa-search"></i>
                </button>
            </div>
        </label>

        <!-- Search Results Dropdown -->
        <div v-if="searchResults.length > 0" class="card mt-2" style="max-height: 300px; overflow-y: auto;">
            <div class="list-group list-group-flush">
                <button 
                    v-for="part in searchResults" 
                    :key="part.Id"
                    class="list-group-item list-group-item-action text-start"
                    @click="selectPart(part)"
                >
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                            <div class="fw-bold">{{ part.PartDescription }}</div>
                            <small class="text-muted">
                                Part #: {{ part.PartNumber || 'N/A' }} | 
                                MSRP: ${{ formatMoney(part.MSRP) }} | 
                                Cost: ${{ formatMoney(part.PartsCost) }}
                            </small>
                        </div>
                    </div>
                </button>
            </div>
        </div>

        <!-- No Results Message -->
        <div v-if="searched && searchResults.length === 0" class="alert alert-info mt-2 mb-0">
            No parts found matching "{{ searchQuery }}"
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import Api from "@/services/Api";

const searchQuery = ref("");
const searchResults = ref([]);
const searched = ref(false);
let searchTimeout = null;

const emit = defineEmits(["select"]);

const onSearchInput = () => {
    // Debounce search
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }
    
    searchTimeout = setTimeout(() => {
        if (searchQuery.value && searchQuery.value.length >= 2) {
            performSearch();
        } else {
            searchResults.value = [];
            searched.value = false;
        }
    }, 300);
};

const performSearch = async () => {
    if (!searchQuery.value || searchQuery.value.length < 2) {
        return;
    }

    try {
        const results = await Api.searchParts(searchQuery.value, true);
        searchResults.value = results || [];
        searched.value = true;
    } catch (error) {
        console.error("Error searching parts:", error);
        searchResults.value = [];
        searched.value = true;
    }
};

const selectPart = (part) => {
    emit("select", part);
    // Clear search after selection
    searchQuery.value = "";
    searchResults.value = [];
    searched.value = false;
};

const formatMoney = (value) => {
    if (value == null || value === "") return "0.00";
    return parseFloat(value).toFixed(2);
};
</script>

<style scoped>
.list-group-item {
    cursor: pointer;
}

.list-group-item:hover {
    background-color: #f8f9fa;
}
</style>
